import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import SparePartTile from '@/ui/views/spareparts/SparePartTile.vue';
import dictionaryService from '@/core/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'SparePartsCategoryListPrivate',
  props: {
    model: null
  },
  emits: ["ear"],
  setup(__props: any, { emit }: { emit: ({ (e: 'ear', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { model: Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.FindSparePartPageViewModel }



const activeTabIndex = ref<number>(0);

onMounted(updateEar);

const categoriesWithProducts = computed<Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartCategoryViewObject[]>(() => {
  return props.model.categories.filter(category => props.model.products.some(product => product.categoryId === category.id));
});

const categories = computed<{ id: string, name: string }[]>(() =>
    [{ id: '', name: dictionaryService.get('Pages.SparepartsCategoryOverview.AllLabel') }]
        .concat(categoriesWithProducts.value.map(x => ({ id: x.id, name: x.displayName }))));

function productsForCategory(id: string): Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartProductViewObject[] {
  return props.model.products.filter(product => product.categoryId === id);
}

const productsForCurrentCategory = computed<Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartProductViewObject[]>(() => {
  return activeTabIndex.value === 0 || activeTabIndex.value.id === '' ? props.model.products : productsForCategory(activeTabIndex.value.id);
});

function amount(id: string) {
  return id === '' ? props.model.products.length : productsForCategory(id).length;
}

function setActiveTabIndex(index: number) {
  if (activeTabIndex.value === index) {
    return;
  }
  activeTabIndex.value = index;
  updateEar();
}

function updateEar() {
  emit('ear', productsForCurrentCategory.value.length);
}

return { __sfc: true,props, emit, activeTabIndex, categoriesWithProducts, categories, productsForCategory, productsForCurrentCategory, amount, setActiveTabIndex, updateEar, SparePartTile }
}

})